import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute left-0"
}

import BackButton from "@/components/buttons/BackButton.vue";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useSafeBack, RouteName } from "@/utils/useSafeBack";



export default /*@__PURE__*/_defineComponent({
  __name: 'PageTitleWithBackButton',
  props: {
    pageTitle: {},
    backRouteName: { default: ROUTE_NAMES.HOME },
    titleAlign: { default: "center" },
    onBack: {}
  },
  setup(__props: any) {

const { safeBack } = useSafeBack();

const props = __props;

const alignMap = {
  left: "text-left",
  center: "text-center w-full",
} as const;

const containerMap = {
  left: "flex gap-4",
  center: "relative",
};

function handleBack() {
  if (props.onBack) {
    props.onBack();
  } else {
    safeBack(props.backRouteName);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["items-center xl:hidden mb-6", containerMap[props.titleAlign]])
  }, [
    (__props.titleAlign === 'center')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(BackButton, { onClicked: handleBack })
        ]))
      : (_openBlock(), _createBlock(BackButton, {
          key: 1,
          onClicked: handleBack
        })),
    _createElementVNode("h2", {
      class: _normalizeClass(["text-2xl font-medium leading-[32px] text-brown", alignMap[__props.titleAlign]])
    }, _toDisplayString(__props.pageTitle), 3)
  ], 2))
}
}

})